export default __webpack_public_path__ + "static/media/wfmz69.62581fce.jpg";